export default "__VITE_PUBLIC_ASSET__b54c9a2d__"